import { createContext } from 'react';
const MapContext = createContext({
    mapInstance: null,
});
export default MapContext;
//# sourceMappingURL=MapContext.js.map